/*
 * GNMK（新业务系统）角色常量与权限判断，供页面、指令与脚本共用。
 */
import { HMStoreService } from 'kestrel-core-ui';

/** 新业务系统预置角色编码（与首页 gnmk 用户判断一致） */
export const GNMK_ROLES = Object.freeze(['SJGLY', 'RWGLY', 'RWZXY', 'GZCLY', 'ZYSHRY']);

/**
 * @returns {string[]} 当前登录用户的角色编码列表
 */
export function getUserRoleCodes () {
  const userInfo = HMStoreService.getUserinfo() || {};
  return userInfo.roles || [];
}

/**
 * 是否为新业务系统专属角色用户（拥有任一 {@link GNMK_ROLES} 中的角色）
 */
export function isGnmkUser () {
  const roles = getUserRoleCodes();
  return roles.some(role => GNMK_ROLES.includes(role));
}

/**
 * 当前用户是否拥有传入角色中的至少一个（任一满足即可显示，用于按钮/区块等）
 * @param {...string} roleCodes 角色编码，如 hasGnmkRoles('RWGLY', 'SJGLY')
 */
export function hasGnmkRoles (...roleCodes) {
  if (!roleCodes.length) {
    return false;
  }
  const userRoles = getUserRoleCodes();
  return roleCodes.some(code => userRoles.includes(code));
}

/**
 * 当前用户是否同时拥有传入的全部角色（需全部满足）
 * @param {...string} roleCodes
 */
export function hasAllGnmkRoles (...roleCodes) {
  if (!roleCodes.length) {
    return false;
  }
  const userRoles = getUserRoleCodes();
  return roleCodes.every(code => userRoles.includes(code));
}

/**
 * 是否为任务管理员
 * 用于判断任务列表页面中是否显相关操作
 * @returns {boolean}
 */
export function isTaskManager () {
  return hasGnmkRoles('RWGLY');
}

/**
 * 是否为任务执行员
 * 用于判断任务执行页面中是否显示任务执行相关操作
 * @returns {boolean}
 */
export function isTaskExecutor () {
  return hasGnmkRoles('RWZXY');
}

/**
 * 是否为故障处理员
 * 用于判断故障处理页面中是否显示故障处理相关操作
 * @returns {boolean}
 */
export function isFaultHandler () {
  return hasGnmkRoles('GZCLY');
}

/**
 * 是否为资源审核角色用户
 * 用于判断工具、材料模块页面中是否显示待审批 Tab，材料入库、工具归还确认等按钮
 * @returns {boolean}
 */
export function isApprover () {
  return hasGnmkRoles('SJGLY', 'ZYSHRY');
}

/**
 * 是否为数据管理角色用户
 */
export function isDataManager () {
  return hasGnmkRoles('SJGLY');
}
